import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@localina/core';

interface IProps {
    onLogin: () => void;
}

export const UserVerified: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const handleClick = () => {
        props.onLogin();
    };

    return (
        <>
            <p className="auth-layout__text">{t('resetPassword.userVerified')}</p>
            <Button label={t('resetPassword.buttons.login')} onClick={handleClick} />
        </>
    );
};
